type Crumb = {
  key: string
  label: string
  link: string | null
  url: URL
}

type BreadcrumbsProps = {
  crumbs: Crumb[],
}

export function jsonLdBreadcrumbs(props: BreadcrumbsProps) {
  const { crumbs } = props

  return {
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, index) => ({
      '@type': 'ListItem',
      item: {
        '@id': crumb.url,
        name: crumb.label,
        url: crumb.url
      },
      position: index
    }))
  }
}